import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  const navigate = useNavigate();
  
  const [agreeAll, setAgreeAll] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeThirdParty, setAgreeThirdParty] = useState(false);
  const [agreeAge, setAgreeAge] = useState(false);

  const handleAgreeAll = (checked) => {
    setAgreeAll(checked);
    setAgreeTerms(checked);
    setAgreePrivacy(checked);
    setAgreeThirdParty(checked);
    setAgreeAge(checked);
  };

  const handleIndividualChange = (setter, value) => {
    setter(value);
    // 전체 동의 체크 해제
    if (!value) {
      setAgreeAll(false);
    }
  };

  // 필수 항목 모두 동의했는지 확인
  const canProceed = agreeTerms && agreePrivacy && agreeAge;

  const handleSubmit = () => {
    if (!canProceed) {
      alert('필수 약관에 모두 동의해주세요.');
      return;
    }
    navigate('/register', { state: { termsAgreed: true } });
  };

  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms & Policy</h1>

        {/* 전체 동의 */}
        <label className="terms-checkbox terms-checkbox-all">
          <input
            type="checkbox"
            checked={agreeAll}
            onChange={(e) => handleAgreeAll(e.target.checked)}
          />
          <span>이용약관, 개인정보 수집 및 이용에 모두 동의합니다.</span>
        </label>

        {/* 이용약관 동의 */}
        <div className="terms-item">
          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={agreeTerms}
              onChange={(e) => handleIndividualChange(setAgreeTerms, e.target.checked)}
            />
            <span>이용약관 동의 <span className="required">(필수)</span></span>
          </label>
          <div className="terms-content">
            <h3>제1조 (목적)</h3>
            <p>이 약관은 WIZNOBLE (전자상거래 사업자)가 운영하는 사이버 몰(이하 "WIZNOBLE"이라 한다)에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 사이버 몰과 이용자의 권리․의무 및 책임 사항을 규정함을 목적으로 합니다.</p>

            <h3>제2조 (정의)</h3>
            <p>① "몰"이란 WIZNOBLE 회사가 재화 또는 용역(이하 "재화 등"이라 함)을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 등을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의 의미로도 사용합니다.</p>
            <p>② "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</p>
            <p>③ '회원'이라 함은 "몰"에 회원등록을 한 자로서, 계속적으로 "몰"이 제공하는 서비스를 이용할 수 있는 자를 말합니다.</p>
            <p>④ '비회원'이라 함은 회원에 가입하지 않고 "몰"이 제공하는 서비스를 이용하는 자를 말합니다.</p>

            <h3>제3조 (약관 등의 명시와 설명 및 개정)</h3>
            <p>① "몰"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호․모사전송번호․전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보 관리 책임자 등을 이용자가 쉽게 알 수 있도록 "몰"의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.</p>
            <p>② "몰은 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약 철회, 배송책임, 환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.</p>
            <p>③ "몰"은 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래 기본법」, 「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>
            <p>④ "몰"이 약관을 개정할 경우에는 적용 일자 및 개정 사유를 명시하여 현행약관과 함께 몰의 초기화면에 그 적용 일자 7일 이전부터 적용 일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관 내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 "몰"은 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.</p>
            <p>⑤ "몰"이 약관을 개정할 경우에는 그 개정약관은 그 적용 일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지 기간 내에 "몰"에 송신하여 "몰"의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.</p>
            <p>⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관계법령 또는 상관례에 따릅니다.</p>

            <h3>제4조 (서비스의 제공 및 변경)</h3>
            <p>① "몰"은 다음과 같은 업무를 수행합니다.</p>
            <p>1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결</p>
            <p>2. 구매계약이 체결된 재화 또는 용역의 배송</p>
            <p>3. 기타 "몰"이 정하는 업무</p>
            <p>② "몰"은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공 일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다.</p>
            <p>③ "몰"이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.</p>
            <p>④ 전항의 경우 "몰"은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</p>

            <h3>제5조 (서비스의 중단)</h3>
            <p>① "몰"은 컴퓨터 등 정보통신 설비의 보수점검․교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
            <p>② "몰"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</p>
            <p>③ 사업 종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 "몰"은 제8조에 정한 방법으로 이용자에게 통지하고 당초 "몰"에서 제시한 조건에 따라 소비자에게 보상합니다. 다만, "몰"이 보상기준 등을 고지하지 아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 "몰"에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게 지급합니다.</p>

            <h3>제6조 (회원가입)</h3>
            <p>① 이용자는 "몰"이 정한 가입 양식에 따라 회원 정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</p>
            <p>② "몰"은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.</p>
            <p>1. 가입 신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 "몰"의 회원 재가입 승낙을 얻은 경우에는 예외로 한다.</p>
            <p>2. 등록 내용에 허위, 기재누락, 오기가 있는 경우</p>
            <p>3. 기타 회원으로 등록하는 것이 "몰"의 기술상 현저히 지장이 있다고 판단되는 경우</p>
            <p>③ 회원가입 계약의 성립 시기는 "몰"의 승낙이 회원에게 도달한 시점으로 합니다.</p>
            <p>④ 회원은 회원가입 시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 "몰"에 대하여 회원 정보 수정 등의 방법으로 그 변경사항을 알려야 합니다.</p>

            <h3>제7조 (회원 탈퇴 및 자격 상실 등)</h3>
            <p>① 회원은 "몰"에 언제든지 탈퇴를 요청할 수 있으며 "몰"은 즉시 회원탈퇴를 처리합니다.</p>
            <p>② 회원이 다음 각호의 사유에 해당하는 경우, "몰"은 회원자격을 제한 및 정지시킬 수 있습니다.</p>
            <p>1. 가입 신청 시에 허위 내용을 등록한 경우</p>
            <p>2. "몰"을 이용하여 구입한 재화 등의 대금, 기타 "몰"이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우</p>
            <p>3. 다른 사람의 "몰" 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</p>
            <p>4. "몰"을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</p>
            <p>③ "몰"이 회원 자격을 제한, 정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 "몰"은 회원자격을 상실시킬 수 있습니다.</p>
            <p>④ "몰"이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.</p>

            <h3>제8조(회원에 대한 통지)</h3>
            <p>① "몰"이 회원에 대해 통지를 하는 경우, 회원이 "몰"과 미리 약정하여 지정한 전자우편 주소로 할 수 있습니다.</p>
            <p>② "몰"은 불특정 다수 회원에 대한 통지의 경우 1주일 이상 "몰" 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.</p>

            <h3>제9조(구매신청 및 개인정보 제공 동의 등)</h3>
            <p>① "몰"이용자는 "몰"상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, "몰"은 이용자가 구매신청을 함에 있어 다음의 각 내용을 알기 쉽게 제공하여야 합니다.</p>
            <p>1. 재화 등의 검색 및 선택</p>
            <p>2. 받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력</p>
            <p>3. 약관 내용, 청약 철회권이 제한되는 서비스, 배송료․설치비 등의 비용부담과 관련한 내용에 대한 확인</p>
            <p>4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시 (예, 마우스 클릭)</p>
            <p>5. 재화 등의 구매신청 및 이에 관한 확인 또는 "몰"의 확인에 대한 동의</p>
            <p>6. 결제 방법의 선택</p>

            <h3>제10조 (계약의 성립)</h3>
            <p>① "몰"은 제9조와 같은 구매신청에 대하여 다음 각호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.</p>
            <p>② "몰"의 승낙이 제12조 제1항의 수신확인통지 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.</p>

            <h3>제11조 (지급 방법)</h3>
            <p>"몰"에서 구매한 재화 또는 용역에 대한 대금 지급방법은 다음 각호의 방법 중 가용한 방법으로 할 수 있습니다.</p>
            <p>1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</p>
            <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>
            <p>3. 온라인무통장입금</p>
            <p>4. 전자화폐에 의한 결제</p>
            <p>5. 수령 시 대금 지급</p>
            <p>6. 마일리지 등 "몰"이 지급한 포인트에 의한 결제</p>

            <h3>제12조 ~ 제23조</h3>
            <p>수신확인통지, 재화 등의 공급, 환급, 청약 철회, 개인정보보호, 분쟁 해결, 재판권 및 준거법 등에 관한 조항은 전자상거래 등에서의 소비자보호에 관한 법률 및 관계 법령에 따릅니다.</p>

            <h3>부칙</h3>
            <p>이 약관은 2024년 1월 1일부터 시행합니다.</p>
          </div>
        </div>

        {/* 개인정보 수집 및 이용 동의 */}
        <div className="terms-item">
          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={agreePrivacy}
              onChange={(e) => handleIndividualChange(setAgreePrivacy, e.target.checked)}
            />
            <span>개인정보 수집 및 이용 동의 <span className="required">(필수)</span></span>
          </label>
          <div className="terms-content">
            <h3>1. 개인정보 수집목적 및 이용목적</h3>
            
            <h4>(1) 홈페이지 회원 가입 및 관리</h4>
            <p>회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정 이용 방지, 만 14세 미만 아동의 개인정보 처리시 법정대리인의 동의 여부 확인, 각종 고지․통지, 고충 처리 등의 목적</p>

            <h4>(2) 재화 또는 서비스 제공</h4>
            <p>물품 배송, 서비스 제공, 계약서․청구서 발송, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금 결제 및 정산, 채권추심 등의 목적</p>

            <h4>(3) 고충 처리</h4>
            <p>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리 결과 통보 등</p>

            <h3>2. 수집하는 개인정보 항목</h3>
            <p>ID, 성명, 비밀번호, 주소, 휴대폰 번호, 이메일, 14세 미만 가입자의 경우 법정대리인 정보</p>

            <h3>3. 개인정보 보유 및 이용기간</h3>
            <p>회원탈퇴 시까지 (단, 관계 법령에 보존 근거가 있는 경우 해당 기간 시까지 보유, 개인정보처리방침에서 확인 가능)</p>
          </div>
        </div>

        {/* 개인정보 제3자 제공 동의 */}
        <div className="terms-item">
          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={agreeThirdParty}
              onChange={(e) => handleIndividualChange(setAgreeThirdParty, e.target.checked)}
            />
            <span>개인정보 제3자 제공 동의 (선택)</span>
          </label>
          <div className="terms-content">
            <p>다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
            <p><strong>1. 개인정보를 제공받는 자 :</strong> 예) ㅇㅇㅇ카드</p>
            <p><strong>2. 제공받는 자의 개인정보 이용목적 :</strong> 예) 이벤트 공동개최 등 업무제휴 및 제휴카드 발급</p>
            <p><strong>3. 제공하는 개인정보 항목 :</strong> 예) 성명, 주소, 휴대폰번호, 이메일</p>
            <p><strong>4. 제공받는 자의 보유 및 이용기간 :</strong> 예) 회원탈퇴 시 또는 개인정보 제3자 제공 철회 시까지</p>
          </div>
        </div>

        {/* 만 14세 이상 */}
        <div className="terms-item terms-item-simple">
          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={agreeAge}
              onChange={(e) => handleIndividualChange(setAgreeAge, e.target.checked)}
            />
            <span>만 14세 이상입니다. <span className="required">(필수)</span></span>
          </label>
        </div>

        {/* 버튼 */}
        <div className="terms-buttons">
          <button 
            type="button" 
            className="btn-cancel"
            onClick={() => navigate('/login')}
          >
            취소
          </button>
          <button 
            type="button" 
            className="btn-submit"
            onClick={handleSubmit}
            disabled={!canProceed}
          >
            가입하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Terms;
